// https://www.youtube.com/watch?v=Hf4MJH0jDb4


import React, { useEffect, useState } from "react";
import { Image, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { triggerAlert } from "../../Partials/AlertModal";

const Logout = () => {
  triggerAlert({
    show: true,
    title: "Logout",
    message: "Are you sure?",
    closeOnTouchOutside: true,
    closeOnHardwareBackPress: true,
    showCancelButton: true,
    cancelText: "Stay",
    onCancelPressed: () => {
      triggerAlert();
    },
    showConfirmButton: true,
    confirmButtonColor: window.main.theme.colors.caution,
    confirmText: "Logout",
    onConfirmPressed: async () => {
      triggerAlert();
      await window.main.axios.post(window.main.api.logout);
      window.main.lib.setUserProfile({});
      window.main.lib.setTempIsLoggedin(false);
      window.main.lib.setTempIsSessionChecked(true);
      window.main.lib.triggerMainState();
      window.main.lib.setCurrentView("login");
      window.main.lib.setLoadingState(false);
    },
  });
};

export default Logout;
